import React from 'react';
import { gql } from 'graphql-tag';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';
import PricingForm from '../../../../components/SiteAdmin/Pricing/PricingForm';
import { withQuery } from '../../../../hoc/withGraphql';

class AddPricing extends React.Component {

  render() {
    const { locations, categories, subCategories } = this.props;

    return (
      <PricingForm
        locations={locations}
        categories={categories}
        subCategories={subCategories}
        initialValues={{ currency: 'USD', isActive: 'true' }}
      />
    );
  }
}

export default compose(
  injectIntl,
  withQuery(gql`
    query {
      getAllLocation {
          results {
              id
              locationName
              isActive
          }
          status
      }
    }`, {
    name: 'locations',
    options: (props) => ({
      ssr: false,
      fetchPolicy: 'network-only'
    })
  }),
  withQuery(gql`
      query {
        getActiveCategories {
        results{
            id
            name
            pricingType
        }
        status
      }
    }`, {
    name: 'categories',
    options: (props) => ({
      ssr: false,
      fetchPolicy: 'network-only'
    })
  }),
  withQuery(gql`
      query {
        getActiveSubCategories {
        results{
            id
            name
            categoryId
        }
        status
      }
    }`, {
    name: 'subCategories',
    options: (props) => ({
      ssr: false,
      fetchPolicy: 'network-only'
    })
  }),
)(AddPricing);
